import { Divider, Stack } from '@mui/material';
import { Rights, Roles, User } from '../../graphql/types';
import UserRoleChip from '../../utils/userRoleChip';

interface Props {
  user: User;
}

const UserRole = ({ user }: Props) => {
  return (
    <Stack direction="row" spacing={0.5} alignItems="center" divider={<Divider orientation="vertical" flexItem />}>
      {user.rights?.includes(Rights.IsSuperAdmin) && <UserRoleChip role={Roles.SuperAdmin} />}
      {user.rights?.includes(Rights.IsIsoManager) && <UserRoleChip role={Roles.IsoManager} />}
      {user.rights?.includes(Rights.IsBroker) && <UserRoleChip role={Roles.Broker} />}
      {user.rights?.includes(Rights.IsMerchant) && <UserRoleChip role={Roles.Merchant} />}
      {user.rights?.includes(Rights.IsInvestor) && <UserRoleChip role={Roles.Investor} />}
      {user.rights?.includes(Rights.IsFunder) && <UserRoleChip role={Roles.Funder} />}
      {user.rights?.includes(Rights.IsUser) && <UserRoleChip role={Roles.User} />}
      {user.rights?.includes(Rights.IsLegal) && <UserRoleChip role={Roles.Legal} />}
      {user.rights?.includes(Rights.IsCollection) && <UserRoleChip role={Roles.Collections} />}
      {user.rights?.includes(Rights.IsSubmission) && <UserRoleChip role={Roles.Submission} />}
      {user.rights?.includes(Rights.IsSubmissionAdmin) && <UserRoleChip role={Roles.SubmissionAdmin} />}
      {user.rights?.includes(Rights.IsPreUnderwriter) && <UserRoleChip role={Roles.PreUnderwriter} />}
      {user.rights?.includes(Rights.IsUnderwriter) && <UserRoleChip role={Roles.Underwriter} />}
    </Stack>
  );
};

export default UserRole;
